<mat-form-field appearance="outline" class="form-array w-100" floatLabel="always">
  <mat-label>{{label}}</mat-label>

  <!-- Hidden matInput plugs into formControl -->
  <template [ngTemplateOutlet]="inputTemplate"></template>
  <input class="d-none" lcTestId matInput [errorStateMatcher]="matcher" [formControl]="formControl">

  <ng-container [ngTemplateOutlet]="optionsList" />

  @if (formControl?.invalid) {
    <mat-error class="error-message" [innerHTML]="errors" />
  }

  <mat-hint>
    {{hint}}
  </mat-hint>

</mat-form-field>

<ng-template #optionsList>
  <mat-list class="height-auto h-100 p-0 fx-column">

    <!-- List of all uploaded files-->
    @for (childForm of form?.forms; track $index) {
      <mat-list-item #listItem="hovered" class="border-bottom py-1 font-size-inherit" lcHovered>

        <div class="w-100 fx-row y-start fx-gap-sm" [style.min-height.px]="44">

          <!-- Display file icon and file information-->
          <template [ngTemplateOutlet]="childForm.isEdit && editTemplate ? editMode : displayMode"  [ngTemplateOutletContext]="{form: childForm}"></template>

          <ng-template #displayMode>
            <div class="overflow-auto fx-1-1-0">
              <template [ngTemplateOutlet]="viewTemplate" [ngTemplateOutletContext]="{form: childForm}"></template>
            </div>

            <!-- Delete Button: displays when hovered -->
            <div class="delete-button fx-row x-end y-center fx-0-0">
              @if (listItem.isHovered) {

                @if (canEdit && childForm.canEdit !== false ) {
                  <button mat-icon-button (click)="onEdit(childForm)">
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                  </button>
                }

                <button mat-icon-button (click)="onDelete(childForm)">
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
              }

              @if (childForm?.dirty) {
                <span class="dirty-icon">
                  <mat-icon color="primary" matTooltip="Unsaved changes">published_with_changes</mat-icon>
                </span>
              }
            </div>

          </ng-template>

          <ng-template #editMode>
            @if (childForm && editTemplate) {
              <form class="w-100" [formGroup]="childForm">
                <template [ngTemplateOutlet]="editTemplate" [ngTemplateOutletContext]="{form: childForm}"></template>

                <div class="fx-row x-space-between fx-gap-xs">
                  <button mat-stroked-button (click)="onCancel(childForm)">Cancel</button>
                  <button color="primary" mat-raised-button (click)="onDone(childForm)">Save</button>
                </div>
              </form>
            }
          </ng-template>

        </div>
      </mat-list-item>
    }

    @if (canAdd) {
      <mat-list-item class="p-0">
        <button mat-icon-button (click)="form.addControl()">
          <mat-icon>add</mat-icon>
        </button>
      </mat-list-item>
    }
  </mat-list>

</ng-template>
